﻿import Coordinate from '../../../common/coordinate';
import { UnitFormatter } from '../../../formatters';
import clsx from 'clsx';
import useMap from '../../hooks/use-map';

export type LocationProps = {
    coordinates: Coordinate;
    clickable?: boolean;
};

export default function Location(props: LocationProps) {
    const map = useMap();
    const { lng, lat } = props.coordinates;
    return (
        <span
            className={clsx(props.clickable ? 'text-decoration-underline clickable' : '')}
            title={`Longitude: ${lng}, Latitude: ${lat}`}
            onClick={() => {
                map?.goToCoordinates(props.coordinates);
            }}>
            ({UnitFormatter.formatLng(props.coordinates)}, {UnitFormatter.formatLat(props.coordinates)})
        </span>
    );
}
